import React from 'react'
import { Link } from 'react-router'

const TeacherProfileDigest = ({ userProfile: { first_name, last_name, avatar } }) => {
  const generateProfileStyle = avatar => {
    if (avatar) {
      return {
        background: `url(${avatar})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }
    }
  }

  return (
    <div className="profile-digest">
      <Link to="/dashboard/profile">
        <div className="profile-pic" style={generateProfileStyle(avatar)}>
          {!avatar && <i className="fa fa-user" aria-hidden="true" />}
        </div>
      </Link>

      <Link to="/dashboard/profile">
        {first_name && last_name && <span>{`${first_name} ${last_name}`}</span>}
      </Link>
    </div>
  )
}
export default TeacherProfileDigest



// WEBPACK FOOTER //
// ./src/components/teacher/TeacherProfileDigest.js